import { UserTypeOutputWithStatus } from './user-type-output-with-status.model';


export class UserTypeSelectByIdOutput implements IUserTypeSelectByIdOutput {
    status!: number;
    message!: string;
    data!: UserTypeOutputWithStatus;

    constructor(data?: IUserTypeSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? UserTypeOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserTypeSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UserTypeSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUserTypeSelectByIdOutput {
    status: number;
    message: string;
    data: UserTypeOutputWithStatus;
}

